var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebooklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook logo",
    clipPath: "url(#clip0_1086_315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.78669 14V7.43079H-0.000244141V5.06556H1.78669V3.04535C1.78669 1.45785 2.84225 0 5.27446 0C6.25923 0 6.98742 0.09177 6.98742 0.09177L6.93004 2.30049C6.93004 2.30049 6.1874 2.29347 5.377 2.29347C4.49991 2.29347 4.35939 2.68638 4.35939 3.33851V5.06556H6.99976L6.88487 7.43079H4.35939V14H1.78669Z",
    fill: "#00058B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1086_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 14,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebooklogo);
export default __webpack_public_path__ + "static/media/facebook logo.87790042baff8843e77ac912447a6654.svg";
export { ForwardRef as ReactComponent };